module.exports = "<app-wip></app-wip>\n<app-header></app-header>\n<app-post *ngIf=\"selectedPost != null\"></app-post>\n<router-outlet></router-outlet>\n"